/* global completeHeight */

/**
 * Adds/removes the `.nav-scrolled` class on the header once the page scrolls past the header's
 * own height, compensating the main content's top padding to avoid a layout jump. Also keeps the
 * `--header-height` CSS variable up to date, used by global.scss's `scroll-margin-top` so that
 * scrolling to a focused/target element never leaves it hidden behind the fixed header
 * (WCAG 2.4.11 Focus Not Obscured).
 * @returns {void}
 */
function menuFixedOnScroll() {
    const nav = document.querySelector('#header'),
        main = document.querySelector('main');
    let navHeight = completeHeight(nav),
        windowTop = window.pageYOffset || document.body.scrollTop;

    if (windowTop > navHeight) {
        if (!nav.classList.contains('nav-scrolled')) {
            main.style.paddingTop = navHeight + 'px';
        }
        nav.classList.add('nav-scrolled');
    } else {
        nav.classList.remove('nav-scrolled');
        main.style.paddingTop = 0;
    }

    document.documentElement.style.setProperty('--header-height', `${completeHeight(nav)}px`);
}

let menuFixedOnScrollTicking = false;

/**
 * Runs `menuFixedOnScroll` at most once per animation frame, so rapid `scroll` events don't
 * trigger a layout read + style write on every single one (can cause jank on lower-end mobile).
 * @returns {void}
 */
function queueMenuFixedOnScroll() {
    if (menuFixedOnScrollTicking) { return; }
    menuFixedOnScrollTicking = true;
    requestAnimationFrame(() => {
        menuFixedOnScroll();
        menuFixedOnScrollTicking = false;
    });
}

window.addEventListener('load', menuFixedOnScroll);
window.addEventListener('scroll', queueMenuFixedOnScroll);

/**
 * Moves keyboard focus to the page's main content, used by the "skip to content" link.
 * @returns {void}
 */
// eslint-disable-next-line
function skipLinkMain() {
    document.getElementsByTagName('main')[0].focus();
}

/**
 * Moves keyboard focus to the given element when triggered by the Enter or Space key, used by
 * elements that need to defer focus until after their own keydown handling finishes (e.g. the
 * "back to top" button, whose native button activation would otherwise leave focus on an element
 * that becomes `visibility: hidden` once the page scrolls back up).
 * @param {HTMLElement} element Element to focus.
 * @returns {void}
 */
// eslint-disable-next-line
function skipLink(element) {
    if (window.event.code === 'Enter' || window.event.code === 'Space') {
        setTimeout(() => {
            element.focus();
        }, 50);
    }
}

/**
 * Works around a Bootstrap modal bug where opening a modal shifts the fixed header: keeps the
 * header's width fixed while any `.modal` is open. Deferred to DOMContentLoaded because the
 * `.modal` elements (e.g. cookies.php) only exist further down the document.
 * @returns {void}
 */
function fixModalHeaderWidth() {
    const nb = document.querySelector('#header'),
        modals = document.querySelectorAll('.modal');

    modals.forEach(e => {
        e.addEventListener('show.bs.modal', () => {
            nb.style.width = `${nb.offsetWidth}px`;
        });
        e.addEventListener('hidden.bs.modal', () => {
            nb.style.width = 'auto';
        });
    });
}

document.addEventListener('DOMContentLoaded', fixModalHeaderWidth);
